var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGameShows = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Card-Game-Cards--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Card Game Cards Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.26 3.61a1 1 0 1 0 2 0 1 1 0 1 0 -2 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.27 9.37a1.49 1.49 0 0 0 0 -1.17 1.5 1.5 0 0 0 -0.83 -0.83l-6 -2.5a0.25 0.25 0 0 1 -0.15 -0.23V1.53A1.54 1.54 0 0 0 13.72 0H3.14a1.54 1.54 0 0 0 -1.53 1.53v14.81a1.53 1.53 0 0 0 1.53 1.53h0.52a0.25 0.25 0 0 1 0.2 0.09 0.29 0.29 0 0 1 0.05 0.2A1.46 1.46 0 0 0 4 19a1.52 1.52 0 0 0 0.82 0.83l9.78 4a1.47 1.47 0 0 0 0.58 0.12 1.52 1.52 0 0 0 0.59 -0.12 1.5 1.5 0 0 0 0.82 -0.82ZM3.61 2.25A0.25 0.25 0 0 1 3.86 2H13a0.26 0.26 0 0 1 0.17 0.07 0.25 0.25 0 0 1 0.08 0.18v1.36a0.23 0.23 0 0 1 -0.11 0.2 0.26 0.26 0 0 1 -0.24 0l-1.23 -0.51a1.53 1.53 0 0 0 -2 0.82l-4.79 11.6a0.24 0.24 0 0 1 -0.23 0.15h-0.79a0.22 0.22 0 0 1 -0.17 -0.07 0.25 0.25 0 0 1 -0.08 -0.18ZM15 21.62a0.25 0.25 0 0 1 -0.32 0.14l-8.45 -3.5a0.24 0.24 0 0 1 -0.13 -0.32l5.14 -12.35a0.26 0.26 0 0 1 0.33 -0.14L20 9a0.25 0.25 0 0 1 0.14 0.13 0.31 0.31 0 0 1 0 0.19Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.52 14 15 11.38a1 1 0 0 0 -1.58 -0.65l-2.22 1.48a1 1 0 0 0 -0.44 1.06l0.52 2.62a1.06 1.06 0 0 0 0.62 0.75 1 1 0 0 0 0.39 0.07 1 1 0 0 0 0.57 -0.17l2.22 -1.48a1 1 0 0 0 0.44 -1.06Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7.5a1 1 0 1 0 2 0 1 1 0 1 0 -2 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.19 19.5a1 1 0 1 0 2 0 1 1 0 1 0 -2 0",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGameShows);
export default ForwardRef;